<template>
  <div class="section__container padel-plus">
    <div class="columns is-gapless">
      <div class="column is-4">
        <div class="info-column">
          <a href="https://padelplusoficial.com" target="_blank" class="client-link">
            <h4 class="client">PadelPlus</h4>
          </a>
          <h1 class="title">
            <span class="title-padel">Padel</span><span class="title-plus">Plus</span>
          </h1>
          <p class="date">
            {{ $t("padelPlus.duration.title") }}
            {{ $t("padelPlus.duration.date") }}
          </p>
          <p class="role">
            {{ $t("padelPlus.position.title") }}
            {{ $t("padelPlus.position.role") }}
          </p>
          <p class="description">
            {{ $t("padelPlus.description") }}
          </p>
          <ul class="menu-list">
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("padelPlus.bullet1") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("padelPlus.bullet2") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("padelPlus.bullet3") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("padelPlus.bullet4") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("padelPlus.bullet5") }}
            </li>
            <li class="bullet wow animate__animated animate__backInLeft">
              {{ $t("padelPlus.bullet6") }}
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-8">
        <div class="multimedia-container">
          <!-- Ensure 'padelplus-logo-dark.png' is in src/assets/ -->
          <img src="@/assets/pp-completa-desktop2.png" alt="PadelPlus Logo" class="demo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'animate.css';
import WOW from 'wow.js';

export default {
  name: "PadelPlus",
  components: {},
  mounted() {
    new WOW().init(); // Initialize WOW.js for scroll animations
  }
};
</script>

<style lang="scss" scoped>
/* 
  PadelPlus Palette (for reference):
  White: #ffffff
  Black: #000000
  Red: #ff3131 
*/
div.padel-plus {
  background-color: #000000;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 0;

  @media (min-width: 600px) {
    padding: 0;
    min-height: 100vh;
  }

  div.info-column {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 2rem;
    font-family: "Raleway";

    a.client-link {
      text-decoration: none;
      margin-bottom: 0.25rem;
    }

    h4.client {
      align-self: flex-start;
      font-size: 0.8rem;
      font-weight: bold;
      color: #bbbbbb;
      margin: 0;
    }

    h1.title {
      font-family: "Raleway";
      text-align: left;
      font-size: 2.5rem;
      font-weight: bold;
      margin-bottom: 1rem;
    }

    p.date,
    p.role {
      font-family: "Raleway";
      text-align: left;
      font-weight: 700;
      color: #cccccc;
      font-size: 1.2rem;
      margin-bottom: 0.25rem;
    }

    p.description {
      font-family: "Raleway";
      text-align: left;
      font-weight: normal;
      color: #ffffff;
      margin-top: 1.5rem;
      margin-bottom: 1.5rem;
      font-size: 1rem;
      line-height: 1.6;
    }

    ul.menu-list {
      font-family: "Raleway";
      list-style: none;
      padding-left: 0;

      li.bullet {
        text-align: left;
        margin: 0.75rem 0;
        color: #ffffff;
        position: relative;
        padding-left: 1.5em;

        &::before {
          content: "•";
          color: #ff3131;
          font-weight: bold;
          display: inline-block;
          position: absolute;
          left: 0;
          font-size: 1.2em;
        }
      }
    }

    .title-padel {
      color: #ffffff;
    }

    .title-plus {
      color: #ff3131;
    }
  }

  div.multimedia-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 2rem;

    img.demo {
      width: 100%;
      // max-width: 900px;
      max-width: 60vw;
      height: auto;
      object-fit: contain;
    }
  }

  @media (min-width: 769px) {
    .columns.is-gapless {
      display: flex;
      align-items: stretch; // Ensures columns appear to be of the same height for a balanced layout

      >.column {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      div.info-column {
        padding: 3rem;
      }
    }
  }
}
</style>